import React from 'react';
import { Outlet } from 'react-router-dom';

export const AuthLayout: React.FC = () => {
  return (
    <div className="app-layout__auth">
      <Outlet />
    </div>
  );
};
